module.exports = __webpack_public_path__ + "static/make-c5c8054d0042a18c2aa4b8bff03bb6f3.png";